// extracted by mini-css-extract-plugin
export default {"Container":"SidebarLayout_Container__1aAus","Sidebar":"SidebarLayout_Sidebar__Xa0ZD"};